<template>
  <div class="cascader-wrapper">
    <div
      class="column"
      v-for="(item, level) in optionsTree"
      :key="JSON.stringify(item)"
    >
      <div
        class="item"
        v-for="subItem in item"
        :key="subItem.value"
        @click.stop="onClickItem(level, subItem)"
        :title="subItem.label"
      >
        <template v-if="subItem.children && subItem.children.length > 0">
          <div class="label">{{ subItem.label }}</div>
          <Icon class="icon" type="ios-arrow-forward"></Icon>
        </template>
        <template v-else>
          <div class="label">
            <Checkbox
              v-model="subItem.checked"
              @on-change="
                (bool) => {
                  onCheckboxChange(bool, subItem);
                }
              "
            ></Checkbox>
            {{ subItem.label }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SuperTreeCascader",
  props: {
    options: Array,
    value: Array,
  },
  data() {
    return {
      optionsTree: [],
      labelInValue: [],
    };
  },
  watch: {
    options: {
      handler(newValue) {
        if (newValue) {
          this.$set(this.$data, 'optionsTree', [JSON.parse(JSON.stringify(newValue))]);
        }
      },
      immediate: true,
    },
    value: {
      handler(newValue) {
        if (newValue && this.optionsTree.length > 0) {
          const forEach = (list) => {
            list.forEach((item) => {
              this.$set(
                item,
                "checked",
                this.value.findIndex((_item) => _item.value === item.value) > -1
              );
              if (item.children && item.children.length > 0) {
                forEach(item.children);
              }
            });
          };
          forEach(this.optionsTree[0]);
          this.labelInValue = JSON.parse(JSON.stringify(newValue));
        }
      },
      immediate: true,
    },
  },
  methods: {
    onClickItem(level, item) {
      let showLevel = level;
      if (item.children && item.children.length > 0) {
        this.$set(this.optionsTree, level + 1, item.children);
        showLevel++;
      }
      this.optionsTree = this.optionsTree.filter((item, index) => {
        return index <= showLevel;
      });
    },
    onCheckboxChange(bool, data) {
      if (bool) {
        this.labelInValue.push(data);
      } else {
        this.labelInValue = this.labelInValue.filter((item) => {
          return item.value !== data.value;
        });
      }
      this.$emit("input", this.labelInValue);
      this.$emit("on-change", this.labelInValue);
    },
  },
};
</script>
<style lang="stylus" scoped>
.cascader-wrapper
  display flex
  height 100%
  overflow hidden

  .column
    width 0
    flex auto
    border-right 1px solid #ddd
    height 100%
    overflow auto

    &::-webkit-scrollbar
      width 6px
      background-color transparentify

    &::-webkit-scrollbar-thumb
      background #ddd
      border-radius 6px

.check-all
  margin-left 15px

.item
  display flex
  align-items center
  position relative
  cursor pointer
  height 30px

  &:hover
    background #f5f5f5

  .label
    text-overflow ellipsis
    width 100%
    overflow hidden
    white-space nowrap
    padding 0 15px

  .icon
    position absolute
    right 5px
    top 50%
    transform translateY(-50%)
</style>
